"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallAuthRefreshTokenBeRefreshed = exports.shallAuthTokenBeRefreshed = exports.isTokenExpired = void 0;
const jose_1 = require("jose");
const AUTH_JWT_REFRESH_RATE_DENOMINATOR = 5;
const AUTH_REFRESH_JWT_REFRESH_RATE_DENOMINATOR = 21;
const isTokenExpired = (token, expirationThresholdMS = 0) => {
    const tokenContent = (0, jose_1.decodeJwt)(token);
    const tokenExpiration = tokenContent?.exp ?? 0;
    return tokenExpiration * 1000 - Date.now() <= expirationThresholdMS;
};
exports.isTokenExpired = isTokenExpired;
const shallAuthTokenBeRefreshed = (token, defaultExpiration) => (0, exports.isTokenExpired)(token, Math.ceil(defaultExpiration / AUTH_JWT_REFRESH_RATE_DENOMINATOR));
exports.shallAuthTokenBeRefreshed = shallAuthTokenBeRefreshed;
const shallAuthRefreshTokenBeRefreshed = (token, defaultExpiration) => (0, exports.isTokenExpired)(token, Math.ceil(defaultExpiration / AUTH_REFRESH_JWT_REFRESH_RATE_DENOMINATOR));
exports.shallAuthRefreshTokenBeRefreshed = shallAuthRefreshTokenBeRefreshed;
//# sourceMappingURL=jwt.js.map